import Vue from 'vue';

export default [
    {
        pathId: 'pps',
        component: 'payment-plans',
        title: 'Payment Plans',
        icon: 'fa-money-check-alt',
        size: 'sm', //sm, md, lg, xl
        reload: true,
    },
    {
        pathId: 'ppps',
        component: 'pending-plans',
        title: 'Pending Payment Plans',
        icon: 'fa-timer',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        loading: true
    },
    {
        pathId: 'ppss',
        component: 'pending-submissions',
        title: 'Pending Payment Submissions',
        icon: 'fa-credit-card',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        loading: true
    },
    {
        pathId: 'ppls',
        component: 'plans-list',
        title: 'Payment Plans',
        icon: 'fa-money-check-alt',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['type']
    },
    {
        pathId: 'ppp',
        component: 'payment-plan',
        title: 'Payment Plan',
        icon: 'fa-money-check-alt',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'ppap',
        component: 'activate-plan',
        title: 'Activate Plan',
        icon: 'fa-money-check-alt',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'pptp',
        component: 'create-tax-plan',
        title: 'Create Tax Payment Plan',
        icon: 'fa-receipt',
        size: 'md',
        props: ['planId']
    },
    {
        pathId: 'ppat',
        component: 'activate-tax-plan',
        title: 'Activate Tax Plan',
        icon: 'fa-receipt',
        size: 'md',
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'pptrs',
        component: 'plan-requests',
        title: 'User Requests',
        icon: 'fa-message-check',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'pptts',
        component: 'plan-transactions',
        title: 'Plan Transactions',
        icon: 'fa-usd-circle',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'ppttn',
        component: 'new-plan-transaction',
        title: 'New Plan Transactions',
        icon: 'fa-plus',
        size: 'md', //sm, md, lg, xl
        props: ['planId', 'userId']
    },
    {
        pathId: 'ppcs',
        component: 'plan-communications',
        title: 'Plan Communications',
        icon: 'fa-envelopes-bulk',
        size: 'md', //sm, md, lg, xl
        loading: true,
        props: ['planId']
    },
    {
        pathId: 'ppcvc',
        component: 'view-plan-communication',
        title: 'View Communication',
        icon: 'fa-envelopes-bulk',
        size: 'lg', //sm, md, lg, xl
        loading: true,
        props: ['planId', 'refId', 'commId']
    },
    {
        pathId: 'ppns',
        component: 'plan-notes',
        title: 'Plan Notes',
        icon: 'fa-notes',
        size: 'lg', //sm, md, lg, xl
        loading: true,
        props: ['planId', 'userId']
    },
    {
        pathId: 'ppnn',
        component: 'new-plan-note',
        title: 'New Plan Note',
        icon: 'fa-message-plus',
        size: 'lg', //sm, md, lg, xl
        props: ['planId', 'userId']
    },
    {
        pathId: 'ppon',
        component: 'new-plan-offer',
        title: 'New Plan Offer',
        icon: 'fa-envelope-open-dollar',
        size: 'md', //sm, md, lg, xl
        props: ['planId']
    },
    {
        pathId: 'pppls',
        component: 'pending-letters',
        title: 'Pending Letters',
        icon: 'fa-envelope',
        size: 'md', //sm, md, lg, xl
        loading: true,
    },
    {
        pathId: 'ppupm',
        component: 'update-payment-method',
        title: 'Update Payment Method',
        icon: 'fa-university',
        size: 'md', //sm, md, lg, xl
        props: ['planId']
    },
    {
        pathId: 'ppft',
        component: 'failed-transactions',
        title: 'Failed Transactions',
        icon: 'fa-subtitles-slash',
        size: 'md',
        reload: true,
        loading: true
    },
    {
        pathId: 'pppt',
        component: 'pending-transactions',
        title: 'Pending Transactions',
        icon: 'fa-calendar-clock',
        size: 'md',
        reload: true,
        loading: true
    },
    {
        pathId: 'ppar',
        component: 'account-requests',
        title: 'Recent Requests',
        icon: 'fa-message-check',
        size: 'md',
        reload: true,
        loading: true
    },
    {
        pathId: 'rpp',
        component: 'reseller-pending-plans',
        title: 'My Pending Plans',
        icon: 'fa-timer',
        size: 'sm',
        reload: true,
        loading: true
    },
    {
        pathId: 'rpd',
        component: 'reseller-plan-detail',
        title: 'Plan Details',
        icon: 'fa-info-circle',
        size: 'md',
        loading: true,
        props: ['planId']
    },
];

Vue.component('payment-plans', () => import('@/cards/payment_plans/Plans'));
Vue.component('pending-plans', () => import('@/cards/payment_plans/PendingPlans'));
Vue.component('pending-submissions', () => import('@/cards/payment_plans/PendingSubmissions'));
Vue.component('plans-list', () => import('@/cards/payment_plans/PlansList'));
Vue.component('payment-plan', () => import('@/cards/payment_plans/Plan'));
Vue.component('activate-plan', () => import('@/cards/payment_plans/ActivatePlan'));
Vue.component('create-tax-plan', () => import('@/cards/payment_plans/CreateTaxPlan'));
Vue.component('activate-tax-plan', () => import('@/cards/payment_plans/ActivateTaxPlan'));
Vue.component('plan-requests', () => import('@/cards/payment_plans/PlanRequests'));
Vue.component('plan-transactions', () => import('@/cards/payment_plans/Transactions'));
Vue.component('new-plan-transaction', () => import('@/cards/payment_plans/NewTransaction'));
Vue.component('plan-communications', () => import('@/cards/payment_plans/Communications'));
Vue.component('view-plan-communication', () => import('@/cards/payment_plans/ViewCommunication'));
Vue.component('plan-notes', () => import('@/cards/payment_plans/Notes'));
Vue.component('new-plan-note', () => import('@/cards/payment_plans/NewNote'));
Vue.component('new-plan-offer', () => import('@/cards/payment_plans/NewOffer'));
Vue.component('pending-letters', () => import('@/cards/payment_plans/PendingLetters'));
Vue.component('update-payment-method', () => import('@/cards/payment_plans/UpdatePaymentMethod'));
Vue.component('failed-transactions', () => import('@/cards/payment_plans/FailedTransactions'));
Vue.component('pending-transactions', () => import('@/cards/payment_plans/PendingTransactions'));
Vue.component('account-requests', () => import('@/cards/payment_plans/AccountRequests'));
Vue.component('reseller-pending-plans', () => import('@/cards/payment_plans/ResellerPendingPlans'));
Vue.component('reseller-plan-detail', () => import('@/cards/payment_plans/ResellerPlanDetail'));
